import DishManagement from '@/modules/health-consulting-management/dish-management';
import { PermissionMode } from '@/enums/mode.enum';
import { useQuery } from '@/hooks/query.hook';
import DishManagementCreateForm from '../../components/forms/dish-management/create.form';
import DishSliderEdit from '../../components/forms/dish-management/edit.form';
import GroupSlider from '../../components/tables/dish-management/dish-by-list.table';


export default function DishSlider() {
    const { mode } = useQuery();

    const renderContent = () => {
        switch (mode) {
            case PermissionMode.CREATE:
                return <DishManagementCreateForm />;
            case PermissionMode.EDIT:
                return <DishSliderEdit />;
            case PermissionMode.GROUP:
                return <GroupSlider />;
            default:
                return <DishManagement />;
        }
    };
    return <>{renderContent()}</>;
}
